import React from 'react'
import { Table, Col, Button, Glyphicon } from 'react-bootstrap'
import { Scrollbars } from 'react-custom-scrollbars';
import { TextAreaBox } from 'fw/forms';
import { DocumentsGrid } from 'areas/shared/components';
import { DownloadFileLink } from 'fw/components';
import * as Formatting from 'fw/misc/Formatting';
import * as Modals from 'fw/globals/Modals';
import * as API from 'modules/app/API'
import DirectAPI from 'fw/system/API'
import { CommentTypeCombo } from 'areas/shared/controls'

class CommentsGrid extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            newComment: '',
            comments: this.props.comments,
            commentTypeCode : null
        }
    }

    search = (e) => {
        this.setState({
            commentTypeCode: e ? e.value : null
        })
    }

    renderRow = (e, i) => {
        const row = (
            <tr key={i}>
                <td className='col-md-2 react-grid-Cell'>{e.addedBy}</td>
                <td className='col-md-2 react-grid-Cell'>{e.queueTypeDescription}</td>
                <td className='col-md-2 react-grid-Cell'>{e.reviewTypeDescription}</td>
                <td className='react-grid-Cell'>
                    <span dangerouslySetInnerHTML={{ __html: e.content }} />
                    {e.storageToken &&
                        <div>
                            <DownloadFileLink storageToken={e.storageToken} fileName={e.fileName} buttonName={e.fileName} buttonStyle="link" />
                        </div>
                    }
                </td>
                <td className='col-md-2 react-grid-Cell'> {Formatting.formatClientDateTime(e.addedDate)}</td>
                {!this.props.readonly && e.commentTypeCode === "NOR" ? 
                    <td className='react-grid-Cell' align='center' style={{ cursor: 'pointer' }} onClick={() => this.handleDelete(e)}>
                        <Glyphicon glyph='remove' />
                    </td>
                : <td className='react-grid-Cell' align='center' style={{ cursor: 'pointer' }}></td> }
            </tr>
        )
        return [row]
    }

    addComment = (comment) => {
        this.handleAdd(comment, "NOR")
    }

    cleanComment = () => {
        this.setState({
            newComment: ''
        })
    }

    handleCommentChange = (value) => {
        this.setState({
            newComment: value
        })

        if (this.props.onCommentChange)
            this.props.onCommentChange(value);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            comments: nextProps.comments
        });
    }

    handleAdd = (paramComment, paramCommentTypeCode) => {
        
        if (paramCommentTypeCode === undefined)
            paramCommentTypeCode = "NOR";
        // Assign comment from param or from the control itself depending on the origin
        let comment = typeof paramComment === 'string' || paramComment instanceof String ? paramComment : this.state.newComment;

        if (!comment)
            return;

        let comments = this.state.comments;

        const rq = {
            certificationKey: this.props.certificationKey,
            reviewTypeCode: this.props.reviewTypeCode,
            queueTypeCode: this.props.queueTypeCode,            
            commentTypeCode: paramCommentTypeCode,
            content: comment
        }

        API.Admin.post('/comment/addComment', rq, {
            success: (sr) => {
                comments.unshift({
                    commentId: sr.data.commentId,
                    reviewTypeDescription: sr.data.reviewTypeDescription,
                    queueTypeDescription: sr.data.queueTypeDescription,
                    content: sr.data.content,
                    addedDate: sr.data.addedAt,
                    addedBy: sr.data.addedBy,
                    commentTypeCode: sr.data.commentTypeCode
                });

                this.setState({
                    // Only clean the new comment textarea if the action is not a document addition or removal
                    newComment: paramCommentTypeCode !== 'DA' && paramCommentTypeCode !== 'DR' ? '' : this.state.newComment,
                    comments: comments
                });

                if (this.props.onSave)
                    this.props.onSave(comments);
            }
        })
    }

    handleDelete = (comment) => {
        if (!comment) return

        let shortenedContent = comment.content.length > 20 ? comment.content.substr(0, 20) + '&hellip;' : comment.content

        Modals.remove({
            title: 'Removing comment',
            elementType: 'comment',
            name: shortenedContent,
            reason: true,
            onYes: (id, reason) => {
                const rq = {
                    commentId: comment.commentId,
                    entityId: this.props.entityId,
                    reason: reason
                }

                API.Admin.post('/comment/deleteComment', rq, {
                    success: (sr) => {
                        let comments = this.state.comments;
                        comments = comments.filter(x => x.commentId !== comment.commentId);

                        this.setState({ comments: comments });

                        if (this.props.onSave)
                            this.props.onSave(comments);
                    }
                });
            }
        });
    }
    exportData = () => {
        const rq = {
            certificationKey: this.props.certificationKey,
            reviewTypeCode: this.props.reviewTypeCode
        }

        API.Admin.post('/comment/exportComment', rq, {
            success: (sr) => {
                new DirectAPI().download(sr.data)
            }
        })
    }
    
    render() {
        const comments = this.state.comments

        return (
            <React.Fragment>
                <Col md={12}>
                    <h3>
                        {this.props.logSectionTitle} <small>{this.props.logSectionSubtitle}</small>
                        <div className="pull-right" style={{width:"200px"}}>    
                            <CommentTypeCombo 
                                name="commentTypeCode" 
                                className="btn-xs"
                                onChange={this.search}
                                clearable />
                        </div>
                    </h3>
                    <hr />
                </Col>
                <Col md={12}>
                    <Scrollbars style={{ height: 170, border: 'solid hsl(0,0%,80%) 1px' }} autoHide>
                        <Table>
                            <thead>
                                <tr>
                                    <th className='react-grid-HeaderCell'>Added By</th>
                                    <th className='react-grid-HeaderCell'>Queue</th>
                                    <th className='react-grid-HeaderCell'>Tab</th>
                                    <th className='react-grid-HeaderCell'>Comment</th>
                                    <th className='react-grid-HeaderCell'>Date/Time</th>
                                    <th width='8%' className='react-grid-HeaderCell' />
                                </tr>
                            </thead>
                            <tbody>
                                {comments.map((e, i) => {
                                    if (this.state.commentTypeCode == null || this.state.commentTypeCode === e.commentTypeCode)
                                        return this.renderRow(e, i);
									else
										return null;
                                })}
                            </tbody>
                        </Table>
                    </Scrollbars>
                    {this.props.enableExport && (
                        <Button onClick={this.exportData} className='btn btn-default pull-left' style={{ marginTop: 5 }}>
                            <Glyphicon glyph='glyphicon glyphicon-export' style={{ marginRight: 10 }} />
                            Export CSV
                        </Button>
                    )}
                </Col>
                <Col md={12}>
                    <h3>
                        {this.props.commentSectionTitle} <small>{this.props.commentSectionSubtitle}</small>
                    </h3>
                    <hr />
                </Col>
                <Col md={8}>
                    {!this.props.readonly &&
                        <div style={{ marginTop: "5px" }}>
                            <div>
                                <TextAreaBox
                                    value={this.state.newComment}
                                    maxLength={2500}
                                    placeholder='Add comment...'
                                    onChange={this.handleCommentChange}
                                    onEnter={this.handleAdd}
                                />
                                {this.props.showAddButton &&
                                    <div style={{ marginTop: '5px' }}>
                                        <Button onClick={this.handleAdd} bsStyle='default'>
                                            Add Comment
                                        </Button>
                                    </div>
                                }
                                <br />
                            </div>
                        </div>
                    }
                </Col>
                <Col md={4}>
                    <DocumentsGrid
                        documents={this.props.documents}
                        certificationKey={this.props.certificationKey}
                        reviewTypeCode={this.props.reviewTypeCode}
                        entityId={this.props.entityId}
                        onUploadDocument={this.handleAdd}
                        readonly={this.props.readonly} />
                </Col>
            </React.Fragment>)
    }
}

export default CommentsGrid

// Default properties
CommentsGrid.defaultProps = {
    logSectionTitle: 'Reviewer Log – ',
    logSectionSubtitle: 'History of all actions related to this application',
    commentSectionTitle: 'Reviewer Comments – ',
    commentSectionSubtitle: 'Please make any Comments regarding this Application below',
    showAddButton: false
}



// WEBPACK FOOTER //
// ./src/areas/shared/components/commentsGrid/CommentsGrid.js